import { mergeVertices } from 'three/examples/jsm/utils/BufferGeometryUtils.js'

export default function createSlicedModel({
  scene,
  gltfLoader,
  url,
  makeSlicedFrom,

  slicedMeshNames = [],
  rotatingMeshNames = [],

  wobble = null,
  wobbleMeshNames = [],
})
{
  const state = {
    model: null,
    rotatingMeshes: [],
    wobbleMeshes: [],
  }

  gltfLoader.load(url, (gltf) =>
  {
    state.model = gltf.scene

    state.model.traverse((child) =>
    {
      if (!child.isMesh) return

      const geo = child.geometry

      // -----------------------------
      // SLICE (pokeballs)
      // -----------------------------
      if (slicedMeshNames.includes(child.name))
      {
        const { sliced, slicedDepth } = makeSlicedFrom(child.material)
        child.material = sliced
        child.customDepthMaterial = slicedDepth
      }

      // -----------------------------
      // WOBBLE (ditto)
      // -----------------------------
      if (wobble && wobbleMeshNames.includes(child.name))
      {
        // normals if missing
        if (!geo.attributes.normal) geo.computeVertexNormals()

        // tangents REQUIRE UVs
        if (!geo.attributes.uv)
        {
          console.warn('No UVs -> cannot wobble correctly:', child.name)
          return
        }

        // tangents REQUIRE indexed geometry
        if (!geo.index)
          child.geometry = mergeVertices(geo)

        child.geometry.computeTangents()

        // IMPORTANT: actually assign wobble material
        child.material = wobble.material
        child.customDepthMaterial = wobble.depthMaterial

        state.wobbleMeshes.push(child)
      }

      // -----------------------------
      // ROTATE (pokeballs)
      // -----------------------------
      if (rotatingMeshNames.includes(child.name))
        state.rotatingMeshes.push(child)

      child.castShadow = true
      child.receiveShadow = true
    })

    scene.add(state.model)
  })

  return state
}
